import { Button } from "@calcom/ui";
import QuickBooking from "../../bookings/components/QuickBooking";
import type { getTopics } from "topics/lib/getTopics";
import NextAvailableSlot from "../../bookings/components/NextAvailableSlot";
import type { Booking } from "experts/lib/getBookingPropsForExpersIds";

type TopicCardProps = {
  topic: Awaited<ReturnType<typeof getTopics>>[0];
  booking: Booking | null;
  userList: (string | null)[];
  topicNextAvailableSlot: string | null;
  className?: string;
};

export function TopicCard({ topic, userList, booking, topicNextAvailableSlot, className }: TopicCardProps) {
  return (
    <article key={topic.id} className={`border-brand-100 flex flex-col border ${className}`}>
      <header className="bg-brand-50 min-h-44 flex w-full items-end justify-start">
        <div className="flex w-full flex-col items-start justify-end p-6">
          <h2 className="text-2xl lg:text-4xl">{topic.name}</h2>
        </div>
      </header>
      <p className="p-6 text-xl leading-relaxed">{topic.description}</p>
      <footer className="mt-auto grid w-full grid-cols-1 gap-6 p-6 pt-0 md:grid-cols-2">
        <NextAvailableSlot nextAvailableSlot={topicNextAvailableSlot} />
        <Button color="secondary" size="2xl" href={`/consultations/topic/${topic.slug}`}>
          Learn more
          <span className="sr-only">{`about ${topic.slug}`}</span>
        </Button>
        <QuickBooking size="2xl" booking={booking} userList={userList} />
      </footer>
    </article>
  );
}
